export default __webpack_public_path__ + "static/media/1314 cutlery side.89afb282.png";